import { CalculateVehicle } from './CalculateVehicle';

export class CalculateVehicleData {
  vehicle: CalculateVehicle;

  constructor(vehicle: CalculateVehicle) {
    this.vehicle = vehicle;
  }
}
